import m, {VnodeDOM} from "mithril";
import ICustomForm from "../../ICustomForm";
import CFNumber from "../CFNumber";
import h from "../../../ui/design";
import ICustomFormSettings from "../../ICustomFormSettings";
import {parseNumber} from "../../shared/helpers";

export default class NumberDefault extends CFNumber implements ICustomForm
{
    private readonly min;
    private readonly max;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        // Parse [min max] from [aux1 aux2]
        const min = String(this.settings.form.aux1 ?? '')
        const max = String(this.settings.form.aux2 ?? '')
        this.min = min ? Number(min) : undefined;
        this.max = max ? Number(max) : undefined;

    }



    private setNumberFromEvent(e: InputEvent) {
        const value = (<HTMLInputElement>e.currentTarget).value;
        this.setVariable(this.variableName, parseNumber(value, this.min, this.max));
    }

    public view() {
        const form = this.settings.form;
        const questionary = form.questionary;

        const formGroup = m('.form-group', {}, [
            m('label', {
                for: this.variableName
            }, questionary.renderText(questionary.messages.get("clickAndStartTypingNumber"))),
            m('.input-group', {}, [
                m('input', {
                    type: "text",
                    id: this.variableName,
                    disabled: !this.numberInputCell.enabled,
                    tabindex: 1,
                    oninput: (e: InputEvent) => this.setNumberFromEvent(e),
                    onchange: (e: InputEvent) => this.setNumberFromEvent(e),
                    onkeydown: (e: KeyboardEvent&InputEvent) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            this.settings.nextForm();
                        }
                        this.errorMessage = null;
                        this.setNumberFromEvent(e);
                    },
                }),
                form.aux3 ? m('.unit', {}, form.aux3) : null,
            ]),
            this.errorMessage ? m('div.error', {}, this.errorMessage) : null
        ]);

        return this.viewLayout([
            m('form', {}, formGroup),
            m('.', {}, this.checkboxes.map(cell => m(cell))),
        ]);
    }

    oncreate(vnode: VnodeDOM) {
        super.oncreate(vnode);
        const $input = $(vnode.dom).find('input').first();
        const value = this.getVariable(this.variableName);
        $input.val(value === undefined ? '' : Number(value)?.toLocaleString() || '');

        if (window.innerWidth >= h.BC.md) {
            setTimeout(() => {
                $input.focus();
            }, 50);
        }
    }
}